import React from 'react'
import { useGameStateContext } from '../ContextProviders/GameStateContextProvider';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

function LineSelector({lineName, linekey, visible = true, lineCaption}) {
    const gameState = useGameStateContext();
    const onActiveLineChanged = (line, checked) => {
        gameState.setActiveLine(line, checked);
      }

    return visible && (
        <FormControlLabel 
            key={linekey} 
            label={lineCaption}
            sx={{ color: '#FFD700', my: -0.5 }}
            control={
                <Checkbox                  
                    checked={gameState.activeLines.includes(lineName)} 
                    disabled={gameState.state !== 'Idle'}
                    sx={{
                        color: '#808080',
                        '&.Mui-checked': {
                            color: '#FFD700',
                        },
                        '&.Mui-disabled': {
                            color: '#CCCCCC00',
                        }
                    }}
                    onChange={(event) => {
                        onActiveLineChanged(lineName, event.target.checked)
                    }} 
                />
            } 
        />
   )
}

export default LineSelector